var map = {
	"./aclManagement.png": 657,
	"./addresses.png": 658,
	"./brandManagement.png": 659,
	"./brands.png": 660,
	"./configSettings.png": 661,
	"./contacts.png": 662,
	"./customerManagement.png": 663,
	"./customers.png": 664,
	"./dashboard.png": 665,
	"./dataDefinition.png": 666,
	"./lookupDefinition.png": 667,
	"./manageLists.png": 668,
	"./manuallySynced.png": 669,
	"./openCarts.png": 670,
	"./orderList.png": 671,
	"./orderManagement.png": 672,
	"./permissions.png": 673,
	"./productManagement.png": 674,
	"./productStyles.png": 675,
	"./recentlySynced.png": 676,
	"./roles.png": 677,
	"./settings.png": 678,
	"./shippingOptions.png": 679,
	"./tagLayout.png": 680,
	"./users.png": 681
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 201;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sideNav ^\.\/.*$
// module id = 201
// module chunks = 0